import React, { useEffect, useState } from "react";
import { API_URL } from "../../_services/apiUrl";
import { get } from "../../_services/apiService";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const Category = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const navigate = useNavigate();
    const [productCategoryData, setProductCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);

    const GetProductCategoryDetail = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL?.GetProductCategory);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);

                setProductCategoryData(filteredData);
            } else {
                setError('Category Not Avaiable');
            }
        } catch (error) {
            setError('Category Not Avaiable');
        }
        finally {
            setLoading(false);
        }
    };

    const GetProductSubCategoryByCategoryId = async () => {
        try {
            const response = await get(`${API_URL?.GetProductSubCategory}`);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setSubCategoryData(filteredData);
            }
        } catch (error) {
            setSubCategoryData([]);
        }
    };

    useEffect(() => {
        GetProductCategoryDetail();
        GetProductSubCategoryByCategoryId();
    }, []);

    const handleImageError = (e) => {
        e.target.src = './images/defaultImage.jpg';
    };

    const onProductSubCategory = (item) => {
        localStorage.setItem('productCategoryId', item?.productCategoryId);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}`);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}`);
    };

    const onMouseEnter = (categoryId) => {
        const filtered = subCategoryData?.filter(
            (sub) => sub?.productCategoryId === categoryId
        );
        setFilteredSubCategories(filtered || []);
    };

    const onProducts = (item) => {
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <>
            <section className="same_spece categories_wepepr section containe-fluid">
                <div className="hedding">
                    <h2>Our Categories</h2>
                </div>
                <div id="categories" className="owl-carousel owl-theme" data-aos="zoom-in">
                    <Swiper
                        loop={false}
                        infinite={true}
                        autoplay={{ delay: 3000 }}
                        speed={1000}
                        slidesPerView={2}
                        className="mySwiper"
                        breakpoints={{
                            1200: {
                                slidesPerView: 7,
                            },
                            1024: {
                                slidesPerView: 5,
                            },
                            768: {
                                slidesPerView: 4,
                            },
                            572: {
                                slidesPerView: 4,
                            },
                            320: {
                                slidesPerView: 3,
                            }
                        }}
                    >
                        {productCategoryData !== null ? (
                            [...productCategoryData]
                                .sort((a, b) => a.showOrder - b.showOrder)
                                .map((item, index) => {
                                    const matchedSubCategories = subCategoryData.filter(
                                        (sub) => sub.productCategoryId === item.productCategoryId && sub.isDisplay
                                    );

                                    if (matchedSubCategories.length === 0) {
                                        // ❌ Skip rendering if no subcategories
                                        return null;
                                    }

                                    const hasSingle = matchedSubCategories.length === 1;

                                    return (
                                        <SwiperSlide key={index}>
                                            <div className="item">
                                                {hasSingle ? (
                                                    <div className="categories_inner cursor-pointer"  onClick={() => onProducts(matchedSubCategories[0])}>
                                                        <div className="sercal_data">
                                                            <img
                                                                src={item?.imgPath ? `${imageUrl}${item.imgPath}` : './images/defaultImage1.jpg'}
                                                                alt=""
                                                                onError={handleImageError}
                                                            />
                                                        </div>
                                                        <div className="sercal_wepper">
                                                            <img src="./images/sercal-img.png" alt="" />
                                                        </div>
                                                        <p className="curser-pointer category_name">{item?.displayName}</p>
                                                    </div>
                                                ) : (
                                                    <div className="categories_inner cursor-pointer" onClick={() => onProductSubCategory(item)}>
                                                        <div className="sercal_data">
                                                            <img
                                                                src={item?.imgPath ? `${imageUrl}${item.imgPath}` : './images/defaultImage1.jpg'}
                                                                alt=""
                                                                onError={handleImageError}
                                                            />
                                                        </div>
                                                        <div className="sercal_wepper">
                                                            <img src="./images/sercal-img.png" alt="" />
                                                        </div>
                                                        <p className="curser-pointer category_name">{item?.displayName}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                        ) : (
                            <p>No categories available right now.</p>
                        )}

                    </Swiper>
                </div>
                <div className="line_wepper"></div>
            </section >
        </>
    )
}

export default Category;